import axios from 'axios'
import * as AuthSession from 'expo-auth-session'
import { TokenResponse } from 'expo-auth-session'
import Config from 'react-native-config'
import { oauthConfig, oauthDiscovery } from '../constants/oauth'
import { OAuthService } from '../services/oauth'
import { waitFunctionResolve } from '../utils/waitFunctionResolve'

export const $masterAPI = axios.create({ baseURL: Config.MASTER_API_URL })

export const $adapteeAPI = axios.create()

const refreshToken = async () => {
    const tokens = await OAuthService.getTokensFromStorage()

    if (!tokens) {
        throw 'No tokens found'
    }

    const freshTokens = await AuthSession.refreshAsync(
        { clientId: oauthConfig.clientId, refreshToken: tokens.refreshToken },
        oauthDiscovery
    )

    await OAuthService.setTokensToStorage({
        accessToken: freshTokens.accessToken,
        refreshToken: freshTokens.refreshToken!,
        expiresIn: freshTokens.expiresIn!,
        issuedAt: freshTokens.issuedAt,
    })

    $adapteeAPI.defaults.headers.common['Authorization'] = `Bearer ${freshTokens.accessToken}`

    return freshTokens
}

$adapteeAPI.interceptors.response.use(
    (config) => config,
    async (error) => {
        const originalRequest = error.config

        if (
            !(
                error.response.status === 400 &&
                error.response.data.msg === 'Unauthorized access.' &&
                !originalRequest.isRetry
            )
        ) {
            throw error
        }

        originalRequest.isRetry = true

        const freshTokens = (await waitFunctionResolve(() => refreshToken())) as TokenResponse

        originalRequest.headers.Authorization = `Bearer ${freshTokens.accessToken}`

        return $adapteeAPI.request(originalRequest)
    }
)
